import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Image from '../../../components/AppImage';

const TodaysBirthdays = ({ 
  todaysBirthdays = [], 
  onSendWish, 
  onViewContact,
  className = '' 
}) => {
  if (todaysBirthdays?.length === 0) {
    return null;
  }

  const calculateAge = (birthDate) => {
    const today = new Date();
    const birth = new Date(birthDate);
    let age = today?.getFullYear() - birth?.getFullYear();
    const monthDiff = today?.getMonth() - birth?.getMonth();
    
    if (monthDiff < 0 || (monthDiff === 0 && today?.getDate() < birth?.getDate())) {
      age--;
    }
    
    return age;
  };

  return (
    <div className={`bg-gradient-to-r from-primary/10 to-accent/10 border border-primary/20 rounded-lg p-4 lg:p-6 ${className}`}>
      <div className="flex items-center space-x-2 mb-4">
        <div className="w-8 h-8 bg-primary rounded-full flex items-center justify-center">
          <Icon name="Gift" size={18} color="white" />
        </div>
        <h3 className="text-lg font-semibold text-text-primary">
          Today's Birthdays ({todaysBirthdays?.length})
        </h3>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {todaysBirthdays?.map((contact) => (
          <div
            key={contact?.id}
            className="bg-surface rounded-lg p-4 border border-border shadow-card hover-lift transition-micro"
          >
            <div className="flex items-center space-x-3 mb-3">
              <div className="relative">
                <div className="w-12 h-12 rounded-full overflow-hidden bg-muted">
                  {contact?.avatar ? (
                    <Image
                      src={contact?.avatar}
                      alt={contact?.name}
                      className="w-full h-full object-cover"
                    />
                  ) : (
                    <div className="w-full h-full flex items-center justify-center">
                      <Icon name="User" size={24} className="text-text-secondary" />
                    </div>
                  )}
                </div>
                <div className="absolute -top-1 -right-1 w-6 h-6 bg-primary rounded-full flex items-center justify-center">
                  <Icon name="Gift" size={12} color="white" />
                </div>
              </div>
              
              <div className="flex-1 min-w-0">
                <h4 className="font-medium text-text-primary truncate">
                  {contact?.name}
                </h4>
                <p className="text-sm text-text-secondary">
                  Turning {calculateAge(contact?.dateOfBirth)} today
                </p>
              </div>
            </div>

            <div className="flex space-x-2">
              <Button
                variant="default"
                size="sm"
                onClick={() => onSendWish(contact)}
                iconName="Send"
                iconPosition="left"
                className="flex-1"
              >
                Send Wish
              </Button>
              <Button
                variant="outline"
                size="icon"
                onClick={() => onViewContact(contact)}
              >
                <Icon name="Eye" size={16} />
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default TodaysBirthdays;